// components/Navbar/index.js

import React from "react";
import logo from "../../assets/LR6.png";
import { useState, useEffect } from "react";
import "../../components/Navbar/navbar.css";

const Navbar = () => {
  // const [isSticky, setSticky] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  // Define sections to be use in navbar
  const sections = ["home", "drinks", "news", "disco", "about", "draw"];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.5 }, // Trigger when 50% of section is visible
    );

    // Observe all sections
    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  });

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setSticky(window.scrollY > 0);
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <a href="#home" className="navbar-logo">
          <img
            src={logo}
            alt="loading..."
            className="navbar-logo-img"
            style={{
              width: "90px",
              height: "90px",
            }}
          />
        </a>

        <ul className="nav-menu">
          <li className="nav-item">
            <a
              href="#home"
              className={`nav-link ${activeSection === "home" ? "active" : ""}`}
            >
              Home
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#about"
              className={`nav-link ${activeSection === "about" ? "active" : ""}`}
            >
              About
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#drinks"
              className={`nav-link ${activeSection === "drinks" ? "active" : ""}`}
            >
              Drinks & Food
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#news"
              className={`nav-link ${activeSection === "news" ? "active" : ""}`}
            >
              News & Events
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#disco"
              className={`nav-link ${activeSection === "disco" ? "active" : ""}`}
            >
              Disco
            </a>
          </li>

          <li className="nav-item">
            <a
              href="#draw"
              className={`nav-link ${activeSection === "draw" ? "active" : ""}`}
            >
              Draw
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
